import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { appServices } from '@/data/AppServices';
import type { HomeDashboard } from '@/domain/Models';

export function HomePage() {
  const [dash, setDash] = useState<HomeDashboard | null>(null);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const reload = useCallback(async () => {
    try {
      setDash(await appServices.study.dashboard());
      setError(null);
    } catch (e) {
      setError(String(e));
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  if (error) return <div className="page error-box">{error}</div>;
  if (!dash?.today) return <div className="page muted">加载中…</div>;
  const task = dash.today;
  const minutes = Math.floor(task.studySeconds / 60);
  const resume = dash.resume[0];

  return (
    <div className="page stack">
      <h2 style={{ margin: 0 }}>今日任务</h2>
      <div className="muted">
        连续学习 {dash.streakDays} 天 · 今日已学 {minutes} 分钟
      </div>
      <div className="row" style={{ gap: 8 }}>
        {dash.weekActivity.map((active, i) => (
          <span key={i} aria-hidden>
            {active ? '●' : '○'}
          </span>
        ))}
      </div>

      {resume && (
        <section className="card stack">
          <strong>继续上次学习</strong>
          <div>
            {resume.title} · {resume.subtitle}
          </div>
          <button
            type="button"
            onClick={() => {
              if (resume.kind === 'vocabulary') navigate('/vocabulary/practice');
              else if (resume.kind === 'scenario') navigate(`/scenario/practice/${resume.id}`);
            }}
          >
            {resume.kind === 'vocabulary' ? '继续复习' : '继续情景'}
          </button>
        </section>
      )}

      <section className="card stack">
        <strong>新词学习</strong>
        <div className="muted">
          {task.newWordDone} / {task.newWordTarget}
        </div>
        <div className="progress-bar">
          <span
            style={{
              width: `${task.newWordTarget ? Math.min(100, (task.newWordDone / task.newWordTarget) * 100) : 0}%`,
            }}
          />
        </div>
      </section>
      <section className="card stack">
        <strong>到期复习</strong>
        <div className="muted">
          {task.reviewDone} / {Math.max(task.reviewTarget, task.reviewDone)}
        </div>
        <div className="progress-bar">
          <span
            style={{
              width: `${
                task.reviewTarget ? Math.min(100, (task.reviewDone / Math.max(task.reviewTarget, 1)) * 100) : 0
              }%`,
            }}
          />
        </div>
      </section>

      <button type="button" onClick={() => navigate('/vocabulary/practice')}>
        {task.newWordDone === 0 && task.reviewDone === 0 ? '开始今日学习' : '再练一组词汇'}
      </button>
      <button type="button" className="secondary" onClick={() => navigate('/scenario')}>
        去对练
      </button>
    </div>
  );
}
